<template>
  <el-dialog
    top="15vh"
    class="recipeType-edit__dialog"
    title="修改菜谱分类"
    width="600px"
    :close-on-click-modal="false"
    :before-close="close"
    :visible.sync="visible"
  >
    <el-form
      ref="form"
      :rules="rules"
      :model="form"
      label-width="auto"
      size="small"
      label-suffix=": "
    >
      <el-form-item :label="$t('RecipeManage.listRecipeType')" prop="typeId">
        <!--                    @getRaw="handleProductChange"-->
        <Select
          :query="`${$api.common.cookbook_type_select}`"
          v-model="form.typeId"
          :placeholder="$t('RecipeManage.listRecipeType')"
          :disabledCode="this.rows.map((item) => item.typeId)"
        >
        </Select>
      </el-form-item>
    </el-form>
    <div slot="footer" class="edit-footer">
      <hl-button type="border" @click="close">取消</hl-button>
      <hl-button @click="save" :loading="loading">保存</hl-button>
    </div>
  </el-dialog>
</template>

<script>
import HlButton from '@/components/Button'
import Select from '@/components/CommonForm/Select'
import { languageList } from '@/config/status.js'
export default {
  components: { HlButton, Select },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    rows: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      languageList,
      typeNames: [{}],
      form: {},
      rules: {
        typeId: [{ required: true, message: '请选择菜谱分类', trigger: 'change' }]
      },
      loading: false
    }
  },
  created() {},
  methods: {
    close() {
      this.$emit('update:visible', false)
    },
    checkForm() {
      let pass
      this.$refs.form.validate((valid) => {
        pass = valid
      })
      return pass
    },
    save() {
      if (!this.checkForm()) return
      this.loading = true
      let ids = this.rows.map((item) => {
        return item.id
      })
      let params = {
        ids: ids,
        typeId: this.form.typeId
      }
      const config = {
        headers: {
          'Content-Type': 'application/json'
        }
      }
      let api = this.$api.recipe.update_cookbook_Type
      this.$ajax
        .post(api, params, config)
        .then((res) => {
          this.$message.success(`${this.$t('Common.editSuccess')}`)
          this.close()
          this.$emit('refresh')
        })
        .catch(() => {})
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>
<style lang="scss" scoped>
.recipeType-edit__dialog {
  /deep/.el-dialog__body {
    padding-left: 30px;
  }
  /deep/ .speInput {
    width: 220px !important;
    .el-input.el-input--small.el-input--suffix {
      width: 200px !important;
    }
  }
  .tableDiv {
    background: #eff4fc;
    padding: 8px;
    border-radius: 8px;
  }
  /deep/ .speTab {
    .el-table tr {
      background: #eff4fc !important;
    }
  }
  .add-bt {
    margin-top: 8px;
    width: 100%;
    background: rgba(255, 255, 255, 0);
    border: 2px dashed #dcdfe6;
    border-radius: 4px;
    text-align: center;
    cursor: pointer;
    span {
      color: #2046c7;
    }
    &:hover {
      background: #ffffff;
      border-radius: 4px;
      border: 2px dashed #dadfe6;
    }
    &:active {
      background: #e3e8f0;
      border-radius: 4px;
      border: 2px dashed #dadfe6;
    }
  }
}
</style>
